import {getToken} from '@asocial/fe-utils'
import {Dispatch} from '@reduxjs/toolkit'
import {io, Socket} from 'socket.io-client'
import {changeConnectSocket} from 'entities/app/model'

const STAGE_API = 'https://gochatty.asocial-team.com'

export let socket: Socket

export const socketConnect = (dispatch: Dispatch) => {
  socket = io(
    (process.env.NODE_ENV === 'development' ? STAGE_API : window.location.origin) + '/mirror',
    {
      path: '/ws/socket.io',
      extraHeaders: {Authorization: `Bearer ${getToken()?.accessToken}`}
    }
  )

  socket.on('connect_error', () => {
    socket.io.opts.extraHeaders = {Authorization: `Bearer ${getToken()?.accessToken}`}

    setTimeout(() => socket.connect(), 1000)
  })

  socket.io.on('reconnect', () => {
    dispatch(changeConnectSocket())
  })
}
export const socketDisconnect = () => socket && socket.disconnect()
